import { inject, type ComputedRef } from 'vue'
import type { SalesReport } from '../models/SalesReport'

export function useReportContext() {
  const card = inject<ComputedRef<SalesReport | undefined>>('reportCard')
  const centerId = inject<number>('reportCenterId')
  const srId = inject<string>('reportSrId')

  if (!card || centerId === undefined || srId === undefined)
    throw new Error('useReportContext must be used within a ReportLayout')

  return { card, centerId, srId }
}
